<template><article><h1>Process</h1>
<h2 id="process"><a class="header-anchor" href="#process" aria-hidden="true">#</a> process</h2>
<h3 id="when-the-type-of-process-is-boolean"><a class="header-anchor" href="#when-the-type-of-process-is-boolean" aria-hidden="true">#</a> When the type of <code v-pre>process</code> is <code v-pre>Boolean</code></h3>
<p><example :value="example1"></example></p>
<h3 id="when-the-type-of-process-is-function"><a class="header-anchor" href="#when-the-type-of-process-is-function" aria-hidden="true">#</a> When the type of <code v-pre>process</code> is <code v-pre>Function</code></h3>
<p>When <code v-pre>process</code> is a function, the argument is an array (from smallest to largest slider position), and the function must return an array that can contain any number of progress arrays.</p>
<p>Each progress array represents a segment of the progress bar, and the progress array must contain a start point (index 0) and an end point (index 1), and an optional progress style (index 2).</p>
<p>The position is expressed as a percentage, with <code v-pre>0</code> representing the start point and <code v-pre>100</code> representing the end point.</p>
<p>This function is called whenever the value of the slider changes.</p>
<p><example :value="example2"></example></p>
</article></template>

<script>
  import examples from '@/examples/process.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>